import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { combineReducers } from 'redux';

import {
  AiDashboardContainer,
  aiDashboardReducer,
  defaultAiDashboardSlice,
} from '../../dashboards/ai-dashboard';
import createStore from '../../../store/create-store';

const rootNode = document.getElementById('public-ai-dashboard-root');

const reducer = combineReducers({
  aiDashboard: aiDashboardReducer,
});

const defaultState = {
  aiDashboard: defaultAiDashboardSlice,
};

const store = createStore(reducer, defaultState);

const campaignEnded = rootNode?.dataset.aiCampaignActive !== 'true';

const PublicAiDashboard = () => (
  <Provider store={store}>
    <AiDashboardContainer isPublic campaignEnded={campaignEnded} />
  </Provider>
);

document.addEventListener('DOMContentLoaded', () => {
  const root = createRoot(rootNode);
  root.render(<PublicAiDashboard />);
});
